import { render, staticRenderFns } from "./solutionMobile.vue?vue&type=template&id=6710524e&scoped=true"
import script from "./solutionMobile.vue?vue&type=script&lang=js"
export * from "./solutionMobile.vue?vue&type=script&lang=js"
import style0 from "./solutionMobile.vue?vue&type=style&index=0&id=6710524e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710524e",
  null
  
)

export default component.exports